<div class="container-fluid">
  <h2 class="text-center">Counselling Induction</h2>
  <div class="d-flex float-end">
    <button mat-flat-button color="warn"  (click)="goBack()">Back</button> &nbsp;&nbsp;
    <button mat-flat-button color="primary"  (click)="AddNewRow()"> Add New Row</button>
  </div>
<!--  <mat-form-field appearance="outline" class="col-4">-->
<!--    <mat-label>Induction For </mat-label>-->
<!--    <mat-select [formControl]="counsellors">-->
<!--      <mat-option *ngFor="let e of counsellors$ | async" [value]="e.userName">-->
<!--        {{ e.userName }}-->
<!--      </mat-option>-->
<!--    </mat-select>-->
<!--  </mat-form-field>-->

  <mat-form-field appearance="outline" class="col-4">
    <mat-label>Induction For </mat-label>
    <input matInput [formControl]="counsellors" [readonly]="!!inductionId" placeholder="Enter counsellor name">
  </mat-form-field>
    <!-- No Data Message -->
    <div *ngIf="rows.length === 0" class="alert alert-warning text-center">
      <mat-icon>info</mat-icon>
      <p class="mb-0 mt-2">No data available</p>
    </div>

    <!-- Table -->
    <form [formGroup]="tableForm" *ngIf="rows.length > 0">
      <table mat-table [dataSource]="rows.controls" class="mat-elevation-z2 full-table">

        <!-- SR NO -->
        <ng-container matColumnDef="srNo">
          <th mat-header-cell *matHeaderCellDef class="col-srno"> SR.NO </th>
          <td mat-cell *matCellDef="let row; let i = index"  class="col-srno"> {{ i + 1 }} </td>
        </ng-container>

        <!-- TOPIC -->
        <ng-container matColumnDef="topic">
          <th mat-header-cell *matHeaderCellDef> TOPIC </th>
          <td mat-cell *matCellDef="let row; let i = index" matTooltip="Click to edit"
              matTooltipPosition="above" (click)="cellClick(i, 'topic')">
            {{ row.value.topic }}
          </td>
        </ng-container>

        <!-- INDUCTOR -->
        <ng-container matColumnDef="inductorBy">
          <th mat-header-cell *matHeaderCellDef> INDUCTOR</th>
          <td mat-cell *matCellDef="let row; let i = index" matTooltip="Click to edit"
              matTooltipPosition="above" (click)="cellClick(i, 'inductorBy')">
            {{ row.value.inductorBy }}
          </td>
        </ng-container>

        <!-- DATE -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef class="col-date"> DATE </th>
          <td mat-cell *matCellDef="let row; let i = index"  matTooltip="Click to edit"
              matTooltipPosition="above" (click)="cellClick(i, 'date')"class="col-date">
            {{ row.value.date | date:'dd/MM/yyyy' }}
          </td>
        </ng-container>

        <!-- SUB-TOPIC -->
        <ng-container matColumnDef="subTopic">
          <th mat-header-cell *matHeaderCellDef> SUB-TOPIC </th>
          <td mat-cell *matCellDef="let row; let i = index" matTooltip="Click to edit"
              matTooltipPosition="above" (click)="cellClick(i, 'subTopic')">
            <div [innerHTML]="row.value.subTopic"></div>
          </td>
        </ng-container>

        <!-- DESCRIPTION -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef> DESCRIPTION </th>
          <td mat-cell *matCellDef="let row; let i = index"  matTooltip="Click to edit"
              matTooltipPosition="above"(click)="cellClick(i, 'description')">
            <div [innerHTML]="row.value.description"></div>
          </td>
        </ng-container>

        <!-- FEEDBACK -->
        <ng-container matColumnDef="feedback">
          <th mat-header-cell *matHeaderCellDef> FEEDBACK </th>
          <td mat-cell *matCellDef="let row; let i = index" matTooltip="Click to edit"
              matTooltipPosition="above" (click)="cellClick(i, 'feedback')" class="clickable">
            <div [innerHTML]="row.value.feedback || '<i style=\'color:#999\'></i>'"></div>
          </td>
        </ng-container>

        <ng-container matColumnDef="conductedBy">
          <th mat-header-cell *matHeaderCellDef> INDUCTOR BY </th>
          <td mat-cell *matCellDef="let row; let i = index" matTooltip="Click to edit"
              matTooltipPosition="above"  (click)="cellClick(i, 'conductedBy')"class="clickable">
            <div [innerHTML]="row.value.conductedBy || '<i style=\'color:#999\'></i>'"></div>
          </td>
        </ng-container>


        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="col-action"> ACTIONS </th>

          <td mat-cell *matCellDef="let row; let i = index" class="col-action">

            <button mat-icon-button color="primary" (click)="openEditRowDialog(i)">
              <mat-icon>edit</mat-icon>
            </button>

            <button mat-icon-button color="warn" (click)="deleteRow(i)">
              <mat-icon>delete</mat-icon>
            </button>

          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>
      <div class="d-flex justify-content-center mt-3">
        <button mat-flat-button color="primary"
                (click)="saveInduction()"
                [disabled]="rows.length === 0">
          Submit All
        </button>
      </div>

    </form>

</div>
